"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metricsApi = void 0;
const createApi_1 = require("../../helpers/createApi");
const types_1 = require("./types");
const helpers_1 = require("./helpers");
const getMetrics = (caller) => ({ accountId, payload }) => {
    const res = caller(`/accounts/${accountId}/metrics`).get(payload);
    return res.then((res) => {
        const { _data: data } = res;
        if ('action_trackings' in data) {
            data.action_trackings = data.action_trackings.map((actionTracking) => ({
                ...actionTracking,
                value: (0, helpers_1.parseActionTrackingValue)(actionTracking.value, actionTracking.name),
            }));
        }
        if ('widget_trackings' in data) {
            data.widget_trackings = data.widget_trackings.map((widgetTracking) => ({
                ...widgetTracking,
                value: (0, helpers_1.parseActionTrackingValue)(widgetTracking.value, widgetTracking.name),
            }));
        }
        if ('custom_trackings' in data) {
            data.custom_trackings = data.custom_trackings.map((customTracking) => {
                return {
                    ...customTracking,
                    value: customTracking.created_from === types_1.CreatedFromValues.DATALAYER
                        ? (0, helpers_1.parseCustomTrackingValue)(customTracking.value, customTracking.name)
                        : customTracking.value,
                };
            });
        }
        return {
            ...res,
            _data: data,
        };
    });
};
const postMetric = (caller) => ({ accountId, payload }) => {
    return caller(`/accounts/${accountId}/metrics`).post(payload, { withResponse: true });
};
const patchMetric = (caller) => ({ accountId, payload, metricId }) => {
    let value = {};
    if ((0, helpers_1.isActionTrackingPayload)(payload) && payload.value !== null) {
        value = { value: JSON.stringify(payload.value) };
    }
    return caller(`/accounts/${accountId}/metrics/${metricId}`).patch({ ...payload, ...value });
};
const putTransactionMetric = (caller) => ({ accountId, payload }) => {
    return caller(`/accounts/${accountId}/metrics`).put(payload);
};
const deleteMetric = (caller) => ({ accountId, metricId }) => {
    return caller(`/accounts/${accountId}/metrics/${metricId}`).delete();
};
exports.metricsApi = (0, createApi_1.createAPIFactory)({
    getMetrics,
    postMetric,
    patchMetric,
    putTransactionMetric,
    deleteMetric,
});
//# sourceMappingURL=api.js.map